import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ConsolGroupService {

  constructor(private http: HttpClient) { }

  /**
   * Save Consol Group Form following the standardized pattern
   * @param baseUrl - Base URL from GENERAL_CONFIG
   * @param consolGroupData - The consol group data to save
   * @param globalService - Global service parameters
   * @param filterParams - Filter parameters from AngularJS
   * @param rowData - Row data from AngularJS
   */
  saveConsolGroupForm(
    baseUrl: string,
    consolGroupData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build settings object
    const settingsObj = {
      tax_year: filterParams.tax_year || globalService?.tax_year
    };

    // Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(consolGroupData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(settingsObj) }, params);

    // Set required parameters
    params.is_issue_key_enabled = 'N';
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";

    // Build checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "scenario_key": parseInt(filterParams.scenario || 74)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Build URL with action code (matching original AngularJS)
    const url = `${baseUrl}/saveJsonObject?action_code=1919ok`;

    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key]);
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  /**
   * Generic method to load consol group data if needed
   * @param baseUrl - Base URL from GENERAL_CONFIG
   * @param globalService - Global service parameters
   * @param filterParams - Filter parameters
   */
  loadConsolGroupData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    
    let params = _.merge({}, globalService || {}, filterParams);
    
    const url = `${baseUrl}/loadJsonObject?action_code=1919load`;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key]);
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
